import { createInstance } from "i18next";
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from "react-i18next";
import { fallbacks } from "./fallbacks";
import { convertToZzZz, pseudoizeResource } from "./pseudoization";
import { I18N_NAMESPACE } from "./constants";
const setHTMLTags = (translationsLocale) => {
    if (document && document.body) {
        if (!document.body.className || document.body.className.indexOf("culture-") < 0) {
            document.body.classList.add(`culture-${translationsLocale.toLowerCase()}`);
        }
    }
    if (document && document.documentElement) {
        document.documentElement.lang = translationsLocale;
    }
};
export function initI18n(args) {
    const { localeMessages, defaultMessages, projectName, translationsLocale, baseURL, setCultureOnBody = true, overrides = {}, generatePseudoLoc = convertToZzZz, } = args;
    const nameSpace = I18N_NAMESPACE;
    const lngPath = (lng) => {
        const s3URL = new URL(baseURL);
        const folderName = lng[0].replace("-", "_");
        s3URL.pathname = `/translations/${projectName}/${folderName}/${nameSpace}.json`;
        return s3URL.toString();
    };
    const resources = {};
    if (defaultMessages) {
        resources["en-us"] = {
            resources: defaultMessages,
        };
    }
    if (localeMessages) {
        resources[translationsLocale] = {
            resources: localeMessages,
        };
    }
    if (translationsLocale.toLowerCase() === "zz-zz") {
        resources["zz-zz"] = {
            resources: pseudoizeResource(defaultMessages, generatePseudoLoc),
        };
    }
    const defaulSettings = {
        lng: translationsLocale,
        debug: false,
        defaultNS: nameSpace,
        ns: [nameSpace],
        fallbackLng: fallbacks,
        interpolation: {
            escapeValue: false,
            prefix: "[[",
            suffix: "]]",
        },
        keySeparator: false,
        returnEmptyString: false,
        resources,
        load: "currentOnly",
        lowerCaseLng: true,
        partialBundledLanguages: true,
        backend: {
            crossDomain: true,
            loadPath: (lng) => lngPath(lng),
        },
    };
    if (setCultureOnBody) {
        setHTMLTags(translationsLocale);
    }
    const instance = createInstance(Object.assign(defaulSettings, overrides));
    instance.use(initReactI18next).use(HttpApi).init();
    return instance;
}
//# sourceMappingURL=initializeI18n.js.map